import { render, staticRenderFns } from "./QuotesIcon.vue?vue&type=template&id=63619744&scoped=true"
var script = {}
import style0 from "./QuotesIcon.vue?vue&type=style&index=0&id=63619744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63619744",
  null
  
)

export default component.exports